

export const socialData = {
    mail : "thedhyaniassociates@gmail.com",
    contact1 : "9810106509",
    contact2 : "8595423583",
    instagram : "#",
    facebook:"#",
    linkedin:"#",
    whatsapp:"#",
    x:"#",
    name : 'Anil Dhyani & Associates',
    address:'Chamber no.377 lawyers chamber  block saket  court complex , New Delhi 110017  '
}